import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function FaqSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number>(0);

  const items = [
    { q: t('home.faq.q1'), a: t('home.faq.a1') },
    { q: t('home.faq.q2'), a: t('home.faq.a2') },
    { q: t('home.faq.q3'), a: t('home.faq.a3') },
    { q: t('home.faq.q4'), a: t('home.faq.a4') },
    { q: t('home.faq.q5'), a: t('home.faq.a5') },
  ];

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100/60">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <h2 className="text-center font-heading font-bold text-2xl md:text-4xl text-foreground-950">
          {t('home.faq.title')}
        </h2>

        <div className="mt-8 space-y-3">
          {items.map((item, i) => {
            const open = openIndex === i;
            return (
              <div key={item.q} className="rounded-lg bg-background-50 border border-background-200 overflow-hidden">
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="font-heading font-semibold text-sm md:text-base text-foreground-900">
                    {item.q}
                  </span>
                  <i
                    className={`ri-add-line text-foreground-500 text-lg transition-transform ${
                      open ? 'rotate-45' : ''
                    }`}
                  />
                </button>
                {open && (
                  <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{item.a}</div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}